import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {PhoneNumberFormat, PhoneNumberUtil} from "google-libphonenumber";
import {FormControl, FormGroup} from "@angular/forms";
import {ConstantsService} from "../../../../services/constants/constants.service";
import {PermissionsService} from "../../../../services/permissions/permissions.service";
import {SMS_CONSENT_FEATURE_FLAG, isSamePhoneNumber, isUsPhoneNumber} from "../sms-consent-checkbox/sms-consent";

@Component({
  selector: 'app-edit-reference-recipient',
  templateUrl: './edit-reference-recipient.component.pug',
  styleUrls: ['./edit-reference-recipient.component.scss'],
  standalone: false
})
export class EditReferenceRecipientComponent implements OnInit {

  @Input() recipientToEdit: any;
  @Input() isReference = true;
  @Output() closeEditEvent = new EventEmitter();
  @Output() updatedRecipient = new EventEmitter();
  recipientRow:any = {};
  closeComponent = false;
  recipientLastName!: string;
  disableSend = true;
  @ViewChild("editReferenceRecipientForm") editRecipient: any;
  phoneUtil = PhoneNumberUtil.getInstance();
  errorMessage = {
    'type': '',
    'message': ''
  };

  constructor(private permissions: PermissionsService) {
  }

  ngOnInit(): void {
    this.recipientRow = {...this.recipientToEdit['recipient']};
    this.disableCheck();
  }

  isDirty(): boolean {
    return this.editRecipient.markAsDirty();
  }

  closeEdit() {
    this.closeComponent = true;
    this.closeEditEvent.emit(this.closeComponent);
  }

  disableCheck() {
      if (this.recipientRow.first_name?.trim() && this.recipientRow.last_name?.trim() && this.recipientRow.email && this.recipientRow.mobile_phone && (!this.isReference || (this.isReference && this.recipientRow?.checks?.xref_open_api?.internal_reference?.trim()))) {
          this.disableSend = false;
      } else this.disableSend = true;

  }
  disableCheckAndCheckRoleLength() {
      if (this.isReference && this.recipientRow['checks']['xref_open_api']['internal_reference'].length > 255) {
          this.errorMessage = {
              'type': 'danger',
              'message': ConstantsService.maxLength
          };
          this.disableSend = true;
          return;
      }
      this.disableCheck();
  }

  checkClass(recipient, fields) {
    for (let field of fields) {
      if (recipient.meta.error_fields.indexOf(field) != -1) {
        return 'error';
      } else if (recipient.meta.warning_fields.indexOf(field) != -1) {
        return 'warning';
      }
    }
    return 'none';
  }

  avatarInitials(person: { first_name?: string | null; last_name?: string | null } | null): string {
    const first = (person?.first_name || '').charAt(0);
    const last = (person?.last_name || '').charAt(0);
    return `${first}${last}`;
  }

  recipientDisplayName(person: { first_name?: string | null; last_name?: string | null } | null): string {
    return [person?.first_name, person?.last_name].filter(Boolean).join(' ');
  }

  saveDetails(recipient) {
    let payloadToEdit = {
      "recipient": recipient,
    }
    if ((!this.isReference || (this.isReference && recipient['checks']['xref_open_api']['internal_reference'])) && recipient['first_name'] && recipient['last_name'] && recipient['email'] && this.recipientRow['mobile_phone']) {
        if(this.isReference){
            payloadToEdit['recipient']['internal_reference'] = recipient['checks']['xref_open_api']['internal_reference']
            if (this.showSmsConsent()) payloadToEdit['recipient']['sms_consent'] = !!this.recipientRow['sms_consent']
            else delete payloadToEdit['recipient']['sms_consent']
        }
        delete payloadToEdit['recipient']['checks']
        this.disableSend = false;
        this.updatedRecipient.emit(payloadToEdit);
        this.closeEdit();
    }
  }

  showSmsConsent(): boolean {
    return this.isReference && this.permissions.isFeatureActivated(SMS_CONSENT_FEATURE_FLAG)
      && isUsPhoneNumber(this.recipientRow['country_code'], this.recipientRow['mobile_phone']);
  }

  setSmsConsent(granted: boolean) {
    this.recipientRow['sms_consent'] = granted;
    this.editRecipient.control.markAsDirty();
  }

  phoneUpdate(event) {
    this.editRecipient.control.markAsDirty();
    const updatedPhone = {
      country_code: event['country_code'],
      mobile_phone: event['mobile_phone'] === 'null' ? '' : event['mobile_phone']
    };
    if (!isSamePhoneNumber(this.recipientRow, updatedPhone)) this.recipientRow['sms_consent'] = false;
    this.recipientRow['country_code'] = updatedPhone.country_code;
    this.recipientRow['mobile_phone'] = updatedPhone.mobile_phone;
    let phone = event['country_code'] + event['mobile_phone'];
    let parsedPhone = '';
    try {
      parsedPhone = this.phoneUtil.parseAndKeepRawInput(phone);
      this.recipientRow['mobile'] = this.phoneUtil.format(parsedPhone, PhoneNumberFormat.INTERNATIONAL);
    } catch (e) {
      // needs to be handled in a better way
      console.log("Phone number parsing error: ", e);
    }
    this.disableCheck();
  }

}
